<template>
  <v-dialog width="550" v-model="show" @click:outside="$emit('close')">
    <v-card class="pb-0">
      <v-card-title class="justify-space-between">
        Example of the Sponsors section
        <v-btn fab text small @click="$emit('close')"
          ><v-icon class="text-right">close</v-icon></v-btn
        >
      </v-card-title>
      <v-card-subtitle>
        All attendees will be able to click through to the URL you have
        provided.
      </v-card-subtitle>
      <v-card-text class="d-flex justify-center pb-0">
        <img src="@/assets/image 18.png" />
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    show: { type: Boolean, default: false },
  },
};
</script>

<style>
</style>